import { Stack, Typography } from '@mui/material';
import { LinkReturnToMain } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

import { RoutesConfig } from 'Routes';
export const Title = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.MedicationsHistory);
  const isDesktop = useIsDesktop();
  return (
    <Stack mt={isDesktop ? 0 : 3}>
      <LinkReturnToMain
        link={RoutesConfig.MEDICATION_AND_PRESCRIPTIONS_LOBBY.PATH}
        label={dictionary.titleLink}
        internal
      />
      <Typography variant='h2' component='h1' tabIndex={0} mt={2} mb={2}>
        {dictionary.title}
      </Typography>
      <Typography variant='body2' mb={4}>
        {dictionary.subTitle}
      </Typography>
    </Stack>
  );
};
